import { render, staticRenderFns } from "./SluzbaAutomatizaceDetail.vue?vue&type=template&id=05b4cb22&scoped=true&"
import script from "./SluzbaAutomatizaceDetail.vue?vue&type=script&lang=js&"
export * from "./SluzbaAutomatizaceDetail.vue?vue&type=script&lang=js&"
import style0 from "./SluzbaAutomatizaceDetail.vue?vue&type=style&index=0&id=05b4cb22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b4cb22",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\4g22\\themes\\foreground-theme-2022\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05b4cb22')) {
      api.createRecord('05b4cb22', component.options)
    } else {
      api.reload('05b4cb22', component.options)
    }
    module.hot.accept("./SluzbaAutomatizaceDetail.vue?vue&type=template&id=05b4cb22&scoped=true&", function () {
      api.rerender('05b4cb22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/sluzby/SluzbaAutomatizaceDetail.vue"
export default component.exports